import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

/** Billing now lives under Account Settings → Bills tab */
const Billing = () => {
  const navigate = useNavigate();

  useEffect(() => {
    navigate('/profile?tab=bills', { replace: true });
  }, [navigate]);

  return null;
};

export default Billing;
